export type Validator<T> = (v: T) => string | undefined;

export const requiredWithMessage: (m: string) => Validator<string> =
  (message: string) =>
  (value: string): string | undefined =>
    value ? undefined : message;

export const required: Validator<string> = (value: string): string | undefined =>
  value ? undefined : "Required";
